// extracted by mini-css-extract-plugin
export default {"map":"BefaringInnkomneKartSide-module__map__GJM7L"};